import React from 'react'
import { useTranslation } from 'react-i18next'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import { useState } from 'react'
import ClassicTextField from '@components/@material-extend/ClassicTextField'
import { LoadingButton } from '@mui/lab'
import { Box, InputAdornment, IconButton, Alert } from '@mui/material'
import { FieldValues } from 'react-hook-form'
import _ from 'lodash'
import useLoginForm from './useLoginForm'
import { loginByEmail } from '@store/auth/actions'
import { createMetaSelector } from '@store/metadata/selectors'
import { UserLoginParams } from '@services/auth.services'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

const LoginForm: React.FC = () => {
  const { t } = useTranslation()
  const [showPassword, setShowpassword] = useState<boolean>(false)
  const handleClickShowPassword = () => {
    setShowpassword(!showPassword)
  }
  const { Controller, methods } = useLoginForm()
  const dispatch = useDispatch()

  const loginMeta = createMetaSelector(loginByEmail)
  const meta = useSelector(loginMeta)

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault()
  }

  const {
    control,
    handleSubmit,
    // reset,
    formState: { errors, isDirty, isValid },
  } = methods

  const onSubmit = (values: UserLoginParams) => {
    if (_.isEmpty(errors)) {
      // eslint-disable-next-line no-console
      dispatch(loginByEmail(values))
    }
  }

  return (
    <>
      {meta.error ? (
        <Alert sx={{ mb: 1 }} severity="error">
          {t('ERROR.E000006')}
        </Alert>
      ) : null}
      <Box component="form" onSubmit={handleSubmit(onSubmit)} method="post">
        <Controller
          name="email"
          control={control}
          render={({ field: { ref, ...rest } }: FieldValues) => (
            <Box sx={{ mt: 1, mb: 3, height: 60 }}>
              <ClassicTextField
                {...rest}
                fullWidth
                inputRef={ref}
                name="email"
                placeholder={t('SYSCOMMON.email')}
                label={t('SYSCOMMON.email')}
                error={errors.email ? true : false}
                helperText={errors.email ? errors.email.message : ''}
              />
            </Box>
          )}
        />

        <Controller
          name="password"
          control={control}
          render={({ field: { ref, ...rest } }: FieldValues) => (
            <Box sx={{ mt: 1, mb: 2, height: 80 }}>
              <ClassicTextField
                {...rest}
                fullWidth
                inputRef={ref}
                name="password"
                label={t('SYSCOMMON.password')}
                type={showPassword ? 'text' : 'password'}
                placeholder={t('SYSCOMMON.password')}
                error={errors.password ? true : false}
                helperText={errors.password ? errors.password.message : ''}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      disableRipple
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? (
                        <VisibilityOff
                          style={{ fontSize: 20, marginRight: 5 }}
                        />
                      ) : (
                        <Visibility style={{ fontSize: 20, marginRight: 5 }} />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </Box>
          )}
        />

        <LoadingButton
          fullWidth
          variant="contained"
          type="submit"
          size="large"
          loading={meta.pending}
          disabled={meta.pending || !isDirty || !isValid}
          sx={{ mb: 3 }}
        >
          {t('SYSCOMMON.login_button')}
        </LoadingButton>

        <Link to="/password/forgot/">{t('SYSCOMMON.fogot_password')}</Link>
      </Box>
    </>
  )
}

export default LoginForm
